




















































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";

@Component
export default class GrantsNegotiationLogComponent extends Vue {
  @Prop() appId: number;
  @Prop() title: string;
  @Prop() log: any;
  @Prop() Feedback: any;
  @Prop() ReportType: any;

  actions = _app.actions;
  subjects = _app.subjects;
  // ReportType = "All";
  copyArray = [];

  viewApplication(logId: number) {
    let routeData = this.$router.resolve({
      name: "snapshot",
      params: { appId: this.appId.toString(), logId: logId.toString(), section: 'p' },
    });

    window.open(routeData.href, "_blank");
  }

  /** format the date time */
  formatDateTime(val) {
    return utils.dateFormat(val);
  }
  selectReport() {
    if (this.ReportType == "Technical") {
      if (this.Feedback) {
        this.copyArray = this.log.filter(
          activities =>
            activities.ActivityType == "TechnicalReport" ||
            activities.Entity == "TechnicalReport"
        );
      } else {
        this.copyArray = this.log.filter(
          activities => activities.ActivityType == "TechnicalReport"
        );
      }
    }
    if (this.ReportType == "Financial") {
      if (this.Feedback) {
        this.copyArray = this.log.filter(
          activities =>
            activities.ActivityType == "FinancialReport" ||
            activities.Entity == "FinancialReport"
        );
      } else {
        this.copyArray = this.log.filter(
          activities => activities.ActivityType == "FinancialReport"
        );
      }
    }
    if (this.ReportType == "Grant") {
      if (this.Feedback) {
        this.copyArray = this.log;
      } else {
        this.copyArray = this.log.filter(
          activities => activities.ActivityType == "Grant"
        );
      }
    }
    if (this.ReportType == "Amendment") {
      if (this.Feedback) {
        this.copyArray = this.log;
      } else {
        this.copyArray = this.log.filter(
          activities => activities.ActivityType == "Amendment"
        );
      }
    }
    if (this.ReportType == "All") {
      if (this.Feedback) {
        this.copyArray = this.log;
      } else {
        this.copyArray = this.log;
      }
    }
  }

  get filteredResult() {
    let data = [];
    switch (this.ReportType) {
      case 'All': {
        data = this.log;
      }
        break;
      case 'Financial': {
        data = this.log.filter(x => x.ActivityType == "FinancialReport" ||
          x.Entity == "FinancialReport");
      }
        break;
      case 'Technical': {
        data = this.log.filter(x => x.ActivityType == "TechnicalReport" ||
          x.Entity == "TechnicalReport");
      }
        break;
      case 'Grant': {
        data = this.log.filter(x => x.ActivityType == "Grant" ||
          x.Entity == "Grant");
      }
        break;
      case 'Amendment': {
        data = this.log.filter(x => x.ActivityType == "Amendment");
      }
        break;
    }
    return data;
  }

  @Watch("log", { immediate: true }) onChanged() {
    this.selectReport();
  }
  @Watch("ReportType", { immediate: true }) onReportTypeChanged() {
    this.selectReport();
  }
  @Watch("Feedback", { immediate: true }) onFeedbackChanged() {
    this.selectReport();
  }
}
